import { Form } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';

function HiddenField(props) {
  const { formik } = props;
  const { name } = props;
  const value = objectPath.get(formik.values, name);

  return (
    <>
      <Form.Control
        type="hidden"
        name={name}
        id={name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={value}
      />
    </>
  );
}

export default connect(HiddenField);
